var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.ValidationObserver, {
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "signup-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_setup.submit)
                  },
                },
              },
              [
                _setup.prefilled
                  ? _c("p", { staticClass: "m-0" }, [
                      _vm._v(
                        "\n            We filled in what " +
                          _vm._s(_setup.providerLabel) +
                          " shared with us. Complete the rest to continue.\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.StoreFields, {
                  attrs: {
                    "store-type": _setup.form.storeType,
                    "store-url": _setup.form.storeUrl,
                    "lock-store-type": _vm.lockStoreType,
                  },
                  on: {
                    "update:storeType": _setup.onStoreTypeChange,
                    "update:storeUrl": function ($event) {
                      _setup.form.storeUrl = $event
                    },
                  },
                }),
                _vm._v(" "),
                _setup.appStoreListing
                  ? _c("div", { staticClass: "text-center" }, [
                      _c("p", [
                        _vm._v(
                          "Find us on the " +
                            _vm._s(_setup.appStoreListing.name) +
                            " App Store:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-primary w-100 font-weight-normal",
                          attrs: {
                            href: _setup.appStoreListing.url,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _vm._v(
                            "\n                Install Customily\n            "
                          ),
                        ]
                      ),
                    ])
                  : [
                      _c(_setup.ValidationProvider, {
                        attrs: { rules: "required", name: "Company Name" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors, failed }) {
                                return [
                                  _c(_setup.CInput, {
                                    attrs: {
                                      label: "Company Name*",
                                      placeholder: "Type your company name",
                                      error: failed,
                                      "error-msg": errors[0],
                                    },
                                    model: {
                                      value: _setup.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_setup.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "signup-form-row" },
                        [
                          _c(_setup.ValidationProvider, {
                            attrs: {
                              rules: _setup.prefilled
                                ? "required|alpha_dash"
                                : "required|alpha_num",
                              name: "Username",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors, failed }) {
                                    return [
                                      _c(_setup.CInput, {
                                        attrs: {
                                          label: "Username*",
                                          placeholder: "Type your username",
                                          error: failed,
                                          "error-msg": errors[0],
                                        },
                                        model: {
                                          value: _setup.form.username,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.form,
                                              "username",
                                              $$v
                                            )
                                          },
                                          expression: "form.username",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c(_setup.ValidationProvider, {
                            attrs: { rules: "required|email", name: "Email" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors, failed }) {
                                    return [
                                      _c(_setup.CInput, {
                                        attrs: {
                                          type: "email",
                                          label: "Email*",
                                          placeholder: "Type your email",
                                          disabled: !!_setup.prefilled,
                                          error: failed,
                                          "error-msg": errors[0],
                                        },
                                        model: {
                                          value: _setup.form.email,
                                          callback: function ($$v) {
                                            _vm.$set(_setup.form, "email", $$v)
                                          },
                                          expression: "form.email",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_setup.prefilled
                        ? [
                            _c(
                              "div",
                              { staticClass: "signup-form-row" },
                              [
                                _c(_setup.ValidationProvider, {
                                  attrs: {
                                    rules: "required|min:8",
                                    name: "Password",
                                    vid: "password",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors, failed }) {
                                          return [
                                            _c(_setup.CInput, {
                                              attrs: {
                                                type: "password",
                                                label: "Password*",
                                                placeholder:
                                                  "Type your password",
                                                error: failed,
                                                "error-msg": errors[0],
                                              },
                                              model: {
                                                value: _setup.form.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _setup.form,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.password",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c(_setup.ValidationProvider, {
                                  attrs: {
                                    rules:
                                      "required|min:8|password-confirmed:password",
                                    name: "Password confirmation",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors, failed }) {
                                          return [
                                            _c(_setup.CInput, {
                                              attrs: {
                                                type: "password",
                                                label: "Confirm Password*",
                                                placeholder:
                                                  "Re-enter your password",
                                                error: failed,
                                                "error-msg": errors[0],
                                              },
                                              model: {
                                                value:
                                                  _setup.form
                                                    .confirmationPassword,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _setup.form,
                                                    "confirmationPassword",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.confirmationPassword",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(_setup.ValidationProvider, {
                              attrs: { rules: "required", name: "Captcha" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(_setup.CRecaptcha, {
                                          ref: "recaptchaRef",
                                          attrs: {
                                            error: failed,
                                            "error-msg": errors[0],
                                          },
                                          model: {
                                            value: _setup.captchaToken,
                                            callback: function ($$v) {
                                              _setup.captchaToken = $$v
                                            },
                                            expression: "captchaToken",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        : _vm._e(),
                    ],
                _vm._v(" "),
                _setup.errorMessage
                  ? _c(_setup.CError, {
                      attrs: { message: _setup.errorMessage },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-actions",
                    class: { "single-action": !!_setup.appStoreListing },
                  },
                  [
                    _c(_setup.CButton, {
                      attrs: {
                        variant: "light",
                        text: "Back",
                        disabled: _setup.submitting,
                      },
                      on: {
                        click: function ($event) {
                          return _setup.emit("back")
                        },
                      },
                    }),
                    _vm._v(" "),
                    !_setup.appStoreListing
                      ? _c(_setup.CButton, {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            text: _setup.submitting
                              ? "Signing up..."
                              : "Sign up",
                            disabled: _setup.submitting,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }